import { UserID } from 'types/fde'
import {
  RolodexEntryIndexType,
  RolodexEntryJson,
  RolodexEntryType,
} from 'types/rolodex/rolodexEntries'
import { parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

export type TaggableUser = {
  name: string
  email: string
  id: UserID
}

/**
 * An entry containing a list of users allowed for @ mentions at organization or site level
 * The user list is stored directly in the entry's data field
 * Uses TaggableUser to store only essential user info (id, name, email)
 */
export class GeckoUserList extends GeckoEntryBase<
  {
    users: TaggableUser[]
  },
  {
    organization?: string
    site?: string
  },
  RolodexEntryIndexType
> {
  constructor(json: RolodexEntryJson) {
    const data = {
      users: (json.data.users as TaggableUser[]) || [],
    }
    const tags = {
      organization: parseString(json.tags[RolodexEntryType.ORGANIZATION]),
      site: parseString(json.tags[RolodexEntryType.SITE]),
    }
    super(json, data, tags, {})
  }

  /**
   * Factory method to create a GeckoUserList from raw JSON
   * @param json The raw JSON to create an instance from
   */
  static FromJSON(json: RolodexEntryJson): GeckoUserList | undefined {
    try {
      return new GeckoUserList(json)
    } catch (e) {
      console.error('Failed to create GeckoUserList from JSON', e)
      return undefined
    }
  }
}
